import { TIMEOUT_ERROR } from '@kaltura-ott/tvpil';

import { NETWORK_ERROR, NETWORK_ERROR_FOR_DISPLAY } from 'consts';

export function isNetworkErrorCode(code: string | number | undefined) {
  return Boolean(code && [NETWORK_ERROR, NETWORK_ERROR_FOR_DISPLAY, TIMEOUT_ERROR].includes(code));
}
